const paranthesisNormalize = (text: string) => {
  return text?.replace('{', '')?.replace('}', '');
};

export default paranthesisNormalize;
